
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-truck-line',
      title: 'شحن سريع',
      description: 'توصيل سريع لجميع الطلبات خلال 3-5 أيام عمل'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'دفع آمن',
      description: 'نظام دفع آمن ومشفر لحماية معلوماتك'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'دعم 24/7',
      description: 'فريق دعم متاح على مدار الساعة لمساعدتك'
    },
    {
      icon: 'ri-arrow-go-back-line',
      title: 'إرجاع مجاني',
      description: 'سياسة إرجاع مرنة خلال 30 يوم من الشراء'
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#0D1B2A' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
            لماذا تختارنا؟
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-gray-400">
            نقدم لك أفضل تجربة تسوق مع خدمات متميزة
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="rounded-2xl p-8 text-center transition-all duration-300 hover:transform hover:scale-105"
              style={{ backgroundColor: '#1B2D3E', borderTop: '4px solid #D4A84B' }}
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-6" style={{ backgroundColor: 'rgba(212, 168, 75, 0.15)' }}>
                <i className={`${feature.icon} text-3xl`} style={{ color: '#D4A84B' }}></i>
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                {feature.title}
              </h3>
              <p className="leading-relaxed text-gray-400">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
